PegasusTemplate.FormFields = [];

(function(){
  PegasusTemplate.FormField = Em.Object.extend({
    type: '',
    name: '',
    optional: true,
    required: false,
    placeholder: function(_,value){
      if ( typeof(value) !== 'undefined' ) {
        return value || '';
      }
      return Em.I18n.t( 'form_fields.' + this.get('name') );
    }.property(),

    displayName: function(_,value){
      return Em.I18n.t( 'form_fields.' + this.get('name') );
    }.property(),

    toData: function(){
      return [
        this.get('type'),
        this.get('name'),
        this.get('placeholder'),
        ''+this.get('required')
      ].join('-delimiter-');
    }
  });

  [
    PegasusTemplate.EmailAddressFormField = PegasusTemplate.FormField.extend({
      optional: false,
      required: true,
      type: 'email',
      name: 'email_address'
    }),
    PegasusTemplate.LastNameFormField = PegasusTemplate.FormField.extend({
      type: 'text',
      name: 'last_name'
    }),
    PegasusTemplate.FirstNameFormField = PegasusTemplate.FormField.extend({
      type: 'text',
      name: 'first_name'
    }),
    PegasusTemplate.CompanyNameFormField = PegasusTemplate.FormField.extend({
      type: 'text',
      name: 'company_name'
    }),
    PegasusTemplate.StreetAddressFormField = PegasusTemplate.FormField.extend({
      type: 'text',
      name: 'street_address'
    }),
    PegasusTemplate.ExtendedAddressFormField = PegasusTemplate.FormField.extend({
      type: 'text',
      name: 'extended_address'
    }),
    PegasusTemplate.BirthDateFormField = PegasusTemplate.FormField.extend({
      type: 'date',
      name: 'birth_date'
    }),
    PegasusTemplate.FaxFormField = PegasusTemplate.FormField.extend({
      type: 'text',
      name: 'fax'
    }),
    PegasusTemplate.WorkPhoneFormField = PegasusTemplate.FormField.extend({
      type: 'text',
      name: 'work_phone'
    }),
    PegasusTemplate.HomePhoneFormField = PegasusTemplate.FormField.extend({
      type: 'text',
      name: 'home_phone'
    }),
    PegasusTemplate.MobilePhoneFormField = PegasusTemplate.FormField.extend({
      type: 'text',
      name: 'mobile_phone'
    }),
    PegasusTemplate.WebsiteFormField = PegasusTemplate.FormField.extend({
      type: 'text',
      name: 'website'
    }),
    PegasusTemplate.TitleFormField = PegasusTemplate.FormField.extend({
      type: 'text',
      name: 'title'
    }),
    PegasusTemplate.LocalityFormField = PegasusTemplate.FormField.extend({
      type: 'text',
      name: 'locality'
    }),
    PegasusTemplate.PostalCodeFormField = PegasusTemplate.FormField.extend({
      type: 'text',
      name: 'postal_code'
    }),
    PegasusTemplate.RegionFormField = PegasusTemplate.FormField.extend({
      type: 'text',
      name: 'region'
    })


  ].forEach(function(field){
    PegasusTemplate.FormFields.addObject(field.create());
  });

})();
